"use client";

import { SessionProvider } from "next-auth/react";
import { ThemeProvider } from "@/components/theme/ThemeProvider";
import { GlitchTipBrowser } from "@/components/GlitchTipBrowser";
import { OrderEventsProvider } from "@/components/OrderEventsProvider";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider>
      <GlitchTipBrowser />
      <SessionProvider refetchInterval={15} refetchOnWindowFocus refetchWhenOffline={false}><OrderEventsProvider>{children}</OrderEventsProvider></SessionProvider>
    </ThemeProvider>
  );
}
